import { constants } from "@newsela/angelou";
const white = constants.colors.ui.white[50];

export const ptsLabelCss = {
  fontSize: "1rem",
};

export const ptsCss = (isTwoDigits) => ({
  fontSize: isTwoDigits ? "1.5rem" : "2rem",
});

export const svgCss = {
  alignSelf: "center",
  fill: white,

  tspan: {
    fontWeight: "bold",
  },
};
